import { render, staticRenderFns } from "./zktlgz.vue?vue&type=template&id=0d62a1ac&scoped=true"
import script from "./zktlgz.vue?vue&type=script&lang=js"
export * from "./zktlgz.vue?vue&type=script&lang=js"
import style0 from "./zktlgz.vue?vue&type=style&index=0&id=0d62a1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d62a1ac",
  null
  
)

export default component.exports